import { Operation } from '@/types/general';
import type { RootState } from '@features/redux/store';
import { useQuery } from '@hooks/useQuery';
import { useSelector } from 'react-redux';

export const useOperation = () => {
    const { role } = useSelector(({ auth }: RootState) => auth.Roles);

    const hasId = useQuery().get('id');

    return !role.stores.edit ? Operation.View : hasId ? Operation.Edit : Operation.Create;
};
